export default __webpack_public_path__ + "static/media/logo.d019a0e0.png";